// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".waypoint-input-popper-empty-container{height:36px;display:flex;align-items:center;font-family:Open Sans;font-style:normal;font-weight:600;font-size:12px;line-height:16px;color:#b2b6c0}", ""]);
// Exports
module.exports = exports;
